// extracted by mini-css-extract-plugin
export default {"total-subtotal":"OrderSummaryTotalAmount-module__total-subtotal__JM6Y4","total":"OrderSummaryTotalAmount-module__total__Ks_qH"};